import { useQuery } from 'react-query';

import { CATALOG_FILTER_LOCALE_CONFIG } from '../constants';
import { getCatalogFilterLocaleMetadata } from '../controllers/get-catalog-filter-locale-metadata';

export function useCatalogFilterLocaleMetadata(locale: string | undefined) {
  const shouldFetch = Boolean(locale) && CATALOG_FILTER_LOCALE_CONFIG.TRANSLATED_LOCALES.includes(locale!);

  const {
    data,
    isLoading: catalogFilterLocaleMetadataIsLoading,
    error: catalogFilterLocaleMetadataError,
  } = useQuery(['catalogFilterLocaleMetadata', locale], () => getCatalogFilterLocaleMetadata(locale!), {
    enabled: shouldFetch,
  });

  if (!shouldFetch) {
    return {
      catalogFilterLocaleMetadata: null,
      catalogFilterLocaleMetadataIsLoading: false,
      catalogFilterLocaleMetadataError: null,
    };
  }

  const catalogFilterLocaleMetadata = {
    skills:
      data?.skills?.map((skill) => ({
        label: skill.label,
        value: skill.name,
      })) || [],
  };

  return {
    catalogFilterLocaleMetadata,
    catalogFilterLocaleMetadataIsLoading,
    catalogFilterLocaleMetadataError,
  };
}
